import { BarChart2, ShieldAlert } from 'lucide-react';
import { routesMap } from '../../routes/routesMap';
import { LucideIcon } from 'lucide-react';

export interface HomeCard {
  title: string;
  description: string;
  link: string;
  icon: LucideIcon;
  label: string;
}

export const HOME_CARDS: HomeCard[] = [
  {
    title: "Best Execution",
    description: "Accedi ai report, esplora i dati delle banche e gestisci le fonti.",
    link: routesMap.BEST_EXECUTION_HOME,
    icon: BarChart2,
    label: "Modulo",
  },
  {
    title: "Conduct Risk",
    description: "Accedi ai report, esplora i dati delle banche e gestisci le fonti.",
    link: routesMap.CONDUCT_RISK_HOME,
    icon: ShieldAlert,
    label: "Modulo",
  },
];
